// Real tickers and project names players may not use for launches (production roadmap §2).
// Simulated economy only: no currency or ticker may borrow a real project's name.

export const BLOCKED_TICKERS = new Set([
  "BTC", "ETH", "SOL", "BNB", "XRP", "ADA", "DOGE", "SHIB", "PEPE", "BONK", "WIF", "USDT", "USDC", "DAI", "TRX", "TON",
  "AVAX", "DOT", "LINK", "MATIC", "POL", "LTC", "BCH", "NEAR", "APT", "SUI", "ARB", "OP", "UNI", "AAVE", "ATOM", "FLOKI",
  "WLD", "TIA", "SEI", "INJ", "JUP", "PYTH", "OKB", "HYPE", "TRUMP", "MEME", "FET", "RNDR", "IMX", "STX", "WUSD", "DGN",
]);

export const BLOCKED_NAME_PARTS = [
  "bitcoin", "ethereum", "solana", "binance", "ripple", "cardano", "dogecoin", "shiba inu", "tether", "coinbase", "okx",
  "uniswap", "chainlink", "polygon", "avalanche", "opensea", "metamask", "phantom", "pump.fun", "blur",
];

export function isBlocked(name: string, ticker: string): boolean {
  if (BLOCKED_TICKERS.has(ticker.toUpperCase())) return true;
  const n = name.toLowerCase();
  return BLOCKED_NAME_PARTS.some((b) => n.includes(b));
}
